
var Acr = Acr || {};

Acr.Disclaimer = (function () {


  Utility.log('Disclaimer.js loaded');

  var disclaimer = $('.acr-disclaimer');
  const disclaimerTitle = '.js-disclaimer-title';

  function init() {
    bindDisclaimerEvent('.acr-sup');
    bindDisclaimerEvent('.acr-span');

    $('body').off('click', hideDisclaimer).on('click', hideDisclaimer);

    $('.acr-icon-button-close', '.acr-disclaimer').on('click', function (e) {
      e.stopPropagation();

      $(this).parents('.acr-disclaimer').hide();
    });

    disclaimer.on('click', function (e) {
      e.stopPropagation();
    });
  }

  // Default value '.acr-sup'
  // Bind the disclaimer click event to a elementSelector
  // Could be called in case a disclaimer is created after the init execution
  function bindDisclaimerEvent(elementSelector) {
    $(elementSelector).click(function (e) {
      e.stopPropagation();
      e.preventDefault();

      var $sup = $(e.originalEvent.target);

      var target = $sup.data('target');

      var title = '<sup>' + $sup.data('number') + '</sup>'
        + $sup.data('title');

      $(disclaimerTitle, target).html(title);
      $('p', target).html($sup.data('copy'));

      disclaimer.hide();

      if (disclaimer.height() > $(window).height()) {
        disclaimer.addClass('acr-disclaimer-big');
      }

      $(target).show();
    });
  }

  function hideDisclaimer() {
    disclaimer.hide();
  }

  return {
    init: init,
  };
}());
